//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState } from 'react';

// === COMPONENTS ===
import { Select } from 'components/Select';

// === API ===
import {updateField} from "api/prokey/prokey.websocket";
import {validate} from './validation/index';
import {SUCCESS_CODE} from 'constants/general';

//#endregion

export { validate };

//-----------------------------------------------------------------
export function Selection( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  // const theme    = useTheme();

  const { id, field } = props;

  const [ content , setContent ] = useState( props.value );

  const alt_content       = field.DisplayInfo ? field.DisplayInfo.AltContent      || [] : [];
  const cross_doc_content = field.DisplayInfo ? field.DisplayInfo.CrossDocContent || [] : [];
  const selection_values  = [ ...alt_content, ...cross_doc_content ];

  const items = selection_values.map( x => { return { label: x, value: x } } );
  field.validationInfo.acceptableValues = alt_content;

  const is_auto_mode = localStorage.getItem( 'auto-mode' ) === 'true';

  //#endregion
  
  //#region [STYLES]



  //#endregion

  //#region [EVENTS] 

  //-----------------------------------------------------------------
  function onChange( event ) {
    //-----------------------------------------------------------------
    // setIsChanging(true);
    const value = event.target ? event.target.value : event.value;
    if (event.isSubmit) {
      setContent(value);
      if( event.trigger === 'FORCED' ) {
        props.setMessage('Field has been force accepted!');
        updateField(event.trigger, id, field.Name, { Content: value });
      } else {
        const result = validate(value, field.validationInfo, field.DisplayInfo.Type);
        if (result.message) props.setMessage(result.message);
        if (result.status === SUCCESS_CODE) updateField(event.trigger, id, field.Name, { Content: result.content });
      }
    }
  }

  //-----------------------------------------------------------------
  function onKeyDown( event ) {
    //-----------------------------------------------------------------
    try {
      if (typeof props.onKeyDown === 'function') {
        props.onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }
    } catch (error) {
      console.warn(error);
    }
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Select
        name={props.name}
        id={id}
        inputStyle={props.style}
        options={items}
        value={content}
        forceSelected={true}
        innerRef={props.inputRef}
        has_focus={props.has_focus}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onBlur={props.onBlur}
        disabled={field.isReadOnly}
      />
    );
  }

  //#endregion

  return display();
}